export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-arrow-left-558d18ae8d225dcccbcea6f710c86bdd.svg";